module.exports = __webpack_public_path__ + "img/wbsc-m.1874b9ee.jpg";